import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import { Box, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { openImgModal, setModalImg } from './HRTrainingInfo';

const useStyles = makeStyles({
    Container: {
        "&:hover > .system-img": {
            opacity: 0.4
        },
        "&:hover > div": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
    },
    Tooltip: {
        backgroundColor: "rgba(0,0,0,0.9)!important"
    },
    CaseImg: {
        width: "230px",
    },
    BtnView: {
        backgroundColor: "rgba(0,0,0,0.35)!important"
    },
    HoverPanel: {
        width: "100%",
        backgroundColor: "rgba(0,0,0,0.4)",
        position: "absolute", left: "0px", top: "0px", bottom: "0px", display: "none"
    },
    BackDrop: {
        backgroundClip: "rgba(0,0,0,0.95)!important"
    },
    ProjectItem: {
        marginTop: "15px!important",
        color: "#4A6984!important",
        borderWidth: "1px!important",
        borderRadius: "4px!important",
        borderColor: "#4A6984!important",
        borderStyle: "solid",
        textAlign: "center",
        backgroundColor: "#E7F4FF!important",
    },
});

const Carousel = ({ sources, autoplay = false, navigation = false, delay = 3000 }) => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const modules = [];
    if (autoplay) {
        modules.push(Autoplay);
    }
    if (navigation) {
        modules.push(Navigation);
    }
    const openModal = (imgEl) => {
        dispatch(openImgModal(true));
        dispatch(setModalImg(imgEl));
    }
    return (<><Swiper style={{ height: "100%" }} navigation={false} slidesPerView={1} spaceBetween={20} breakpoints={{
        768: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        },
    }} modules={[...modules]} loop={true} autoplay={{ disableOnInteraction: false, delay: delay }}>
        {
            sources.map((el, index) => {
                return (
                    <SwiperSlide key={index}>
                        <Box>
                            <Box sx={{ width: "100%", height: "200px", textAlign: "center" }} className={classes.Container}>
                                <img src={el.src} width={el.width} height={el.height} alt={el.alt} />
                                <div className={classes.HoverPanel}>
                                    <Button onClick={() => openModal({ src: el.src, alt: el.alt, width: el.width, height: el.height })} disableRipple disableTouchRipple className={classes.BtnView} variant="contained" startIcon={<SearchIcon />}>點擊放大</Button>
                                </div>
                            </Box>
                            <Box className={classes.ProjectItem}>{el.text}</Box>
                        </Box>
                    </SwiperSlide>
                );
            })
        }

    </Swiper></>);
}

export default Carousel;